// ColorPersoCSS
import React from 'react';
import { connect } from 'react-redux';

import StyleDef from './vendor/StyleDef';
import colorLuminance from './vendor/colorLuminance';
import { getHue } from './vendor/colorHue';

@connect((Store) => {
  return {
    brandColor: Store.chat.brandColor,
  };
})
export default class ColorPersoCSS extends React.Component {
  lightifyColor(hex, perc) {
    perc = perc || 85;
    return 'hsl(' + getHue(hex) + ', 50%, ' + perc + '%)';
  }

  render() {
    let _brandColor = this.props.brandColor;

    // _brandColor = '#FFE600'; //debug yellow
    // _brandColor = '#e0edf7'; //debug light blue

    /* if too light, find the nearest adapted color */
    // let lumVariant = -0.1;
    // while ( colorLuminance.isTooLight(_brandColor) ){
    //  _brandColor = colorLuminance.change(_brandColor, lumVariant);
    //  lumVariant -= 0.1
    // }

    /* if too light, just used the default css color */
    if (colorLuminance.isTooLight(_brandColor)) {
      _brandColor = '';
    }

    if (!_brandColor) {
      return <div></div>
    }

    const brandedStyle = `
      .brandedColor_bg {
        background: ${_brandColor} !important;
      }
      .brandedColorLight_bg {
        background: ${this.lightifyColor(this.props.brandColor)} !important;
      }
      .brandedColorLightBis_bg {
        background: ${this.lightifyColor(this.props.brandColor, 92)} !important;
      }
      .brandedColor_color {
        color: ${_brandColor} !important;
      }
      .brandedColorLight_color {
        color: ${this.lightifyColor(this.props.brandColor)} !important;
      }
      .brandedColorLightBis_color {
        color: ${this.lightifyColor(this.props.brandColor, 90)} !important;
      }
      .brandedColor_color_hover:hover {
        color: ${_brandColor} !important;
       }
      .brandedColor_border {
        border-color: ${_brandColor} !important;
      }
      .brandedColorLight_border {
        border-color: ${this.lightifyColor(this.props.brandColor)} !important;
      }
      .brandedColorLightBis_border {
        border-color: ${this.lightifyColor(this.props.brandColor, 90)} !important;
      }
    `;
    return (
      <div>
        <StyleDef content={brandedStyle} />
      </div>
    );
  }
};



// WEBPACK FOOTER //
// ./src/components/ColorPersoCSS.jsx